import offers from '../../api/offers'
import offer from "../../api/offer";

export default {
  state: {
    offers: {data: [], count: 0},
    advertisers: [],
    offerAdvertiserIds: [],
    offerNames: [],
    offerPaysIn: [],
    offerPaysOut: [],
    offerAdvertiserNames: [],
    offerExternalIds: [],
    offerManagerNames: [],
    offerProgramNames: [],
    offerVerticalsNames: [],
    offerCurrencies: [],
    saveOfferStatuses: [],
    saveOfferType: [],
    saveOfferId: [],
    multiplySelectOffers: []
  },
  namespaced: true,
  mutations: {
    async saveOffersStore(state, offers) {
      state.offers = offers
    },
    async saveAdvertisersStore(state, advertisers) {
      state.advertisers = advertisers
    },
    async saveOfferAdvertiserIds(state, offerAdvertiserIds) {
      state.offerAdvertiserIds = offerAdvertiserIds
    },
    async saveOfferAdvertiserNames(state, offerAdvertiserNames) {
      state.offerAdvertiserNames = offerAdvertiserNames
    },
    async saveOfferExternalIds(state, offerExternalIds) {
      state.offerExternalIds = offerExternalIds
    },
    async saveOfferManagerNames(state, offerManagerNames) {
      state.offerManagerNames = offerManagerNames
    },
    async saveOfferVerticalNames(state, offerVerticalNames) {
      state.offerVerticalsNames = offerVerticalNames
    },
    async saveOfferNames(state, offerNames) {
      state.offerNames = offerNames
    },
    async saveOfferPaysIn(state, paysIn) {
      state.offerPaysIn = paysIn
    },
    async saveOfferPaysOut(state, paysOut) {
      state.offerPaysOut = paysOut
    },
    async saveOfferStatuses(state, offerStatuses) {
      state.saveOfferStatuses = offerStatuses
    },
    async saveOfferType(state, offerType) {
      state.saveOfferType = offerType
    },
    async saveOfferId(state, offerId) {
      state.saveOfferId = offerId
    },
    async saveOfferCurrencies(state, currencies) {
      state.offerCurrencies = currencies
    },
    async saveOfferProgramNames(state, offerProgramNames) {
      state.offerProgramNames = offerProgramNames
    },
    saveMultiplySelectOffers(state, offers) {
      state.multiplySelectOffers.length = 0
      state.multiplySelectOffers = offers
    },
    deleteOffer(state, id) {
      state.offers.data = state.offers.data
        .filter(item => (item.id !== id))
    },
    createDuplicateOffer(state, data) {
      const { newOfferId, originOfferId } = data;

      const originalOfferIndex = state.offers.data.findIndex(offer => offer.id === originOfferId);
      if (originalOfferIndex !== -1) {
        const originalOffer = state.offers.data[originalOfferIndex];
        const newOffer = { ...originalOffer, id: newOfferId };
        const newData = [...state.offers.data.slice(0, originalOfferIndex + 1), newOffer, ...state.offers.data.slice(originalOfferIndex + 1)];
        state.offers = {
          count: newData.length,
          data: newData
        };
      }
    },
    massStatusUpdate(state, data) {
      const { offerIds, newStatus } = data;

      offerIds.forEach(offerId => {
        const offerIndex = state.offers.data.findIndex(offer => offer.id === offerId);
        if (offerIndex !== -1) {
          const updatedOffer = { ...state.offers.data[offerIndex], status: newStatus };
          state.offers.data.splice(offerIndex, 1, updatedOffer);
        }
      });
    },

    async updateOfferStore(state, data) {
      const newData = [...state.offers.data];
      const ind = newData.findIndex((offer => offer.id === data.id));
      newData[ind] = {
        ...newData[ind],
        verticalId: data.verticalId,
        conversionType: data.conversionType,
        status: data.status,
        payIn: data.payIn,
        payOut: data.payOut,
        landingPageUrl: data.landingPage,
        featured: data.featured,
        affiliateMultiPings: data.affiliateMultiPings
      };

      state.offers = {
        count: newData.length,
        data: newData
      }
    }
  },
  actions: {
    async saveOffersStore({commit}, data) {

      if (data.filters && data.filters.advertiserName && Object.keys(data.filters.advertiserName).length === 0) {
        data.filters.advertiserName = null;
      }
      console.log(`[OFFERS_STORE_DATA_PAYLOAD] data payLoad:${ JSON.stringify(data)}`);
      const modData = { payload: data }
      commit('saveOffersStore', await offers.getSflOffers(modData))
    },
    async saveOfferAdvertiserIdsStore({commit}, data) {
      commit('saveOfferAdvertiserIds', await offers.getSflOfferAdvertiserIds(data))
    },
    async saveOfferAdvertiserNamesStore({commit}, data) {
      commit('saveOfferAdvertiserNames', await offers.getSflOfferAdvertiserNames(data))
    },
    async saveOfferExternalIdsStore({commit}, data) {
      commit('saveOfferExternalIds', await offers.getSflOfferExternalIds(data))
    },
    async saveOfferManagerNamesStore({commit}, data) {
      commit('saveOfferManagerNames', await offers.getSflOfferManagerNames(data))
    },
    async saveOfferVerticalNamesStore({commit}, data) {
      commit('saveOfferVerticalNames', await offers.getSflOfferVerticalNames(data))
    },
    async saveOfferCurrenciesStore({commit}, data) {
      commit('saveOfferCurrencies', await offers.getSflCurrencies(data))
    },
    async saveOfferNamesStore({commit}, data) {
      commit('saveOfferNames', await offers.getSflOfferNames(data))
    },
    async saveOfferPaysInStore({commit}, data) {
      commit('saveOfferPaysIn', await offers.getSflOfferPaysIn(data))
    },
    async saveOfferPaysOutStore({commit}, data) {
      commit('saveOfferPaysOut', await offers.getSflOfferPaysOut(data))
    },
    async saveOfferStatusesStore({commit}, data) {
      commit('saveOfferStatuses', await offers.getSflOfferStatuses(data))
    },
    async saveOfferTypeStore({commit}, data) {
      commit('saveOfferType', await offers.getSflOfferTypes(data))
    },
    async saveOfferIdsStore({commit}, data) {
      commit('saveOfferId', await offers.getSflOfferIds(data))
    },
    async saveOfferProgramNamesStore({commit}, data) {
      commit('saveOfferProgramNames', await offers.getSflOfferProgramNames(data))
    },
    async saveAdvertisersStore({commit}, data) {
      commit('saveAdvertisersStore', await offers.getAdvertisers(data))
    },
    async delOffer({commit}, data) {
      const {id} = data
      let delOfferResp = await offer.delOffer(id)
      if (delOfferResp) {
        commit('deleteOffer', id)
      }
      return delOfferResp
    },
    async createDuplicateOffer({commit}, data) {
      const {offerId} = data
      let createDuplicateOfferResp = await offer.createDuplicateOffer(offerId)
      if (createDuplicateOfferResp.success) {

        const obj ={
          newOfferId:createDuplicateOfferResp.newOfferId,
          originOfferId:offerId
        }
        commit('createDuplicateOffer', obj)
      }
      return createDuplicateOfferResp
    },
    async massStatusUpdate({ commit }, data) {
      const { offerIds, newStatus } = data;
      let massStatusUpdateResp = await offer.massStatusUpdate(offerIds, newStatus);

      if (massStatusUpdateResp && massStatusUpdateResp.success) {
        const obj = {
          offerIds: offerIds,
          newStatus: newStatus
        };
        commit('massStatusUpdate', obj);
      }

      return massStatusUpdateResp;
    },

    async createMassOffers({commit}, data) {
      return await offer.createMassOffers(data)
    },
    async updateOffer({commit}, data) {
      commit('updateOfferStore', data)
    }
  },
  getters: {
    getOffers: state => state.offers,
    getAdvertisers: state => state.advertisers,
    getOfferAdvertiserIds: state => state.offerAdvertiserIds,
    getOfferNames: state => state.offerNames,
    getOfferPaysIn: state => state.offerPaysIn,
    getOfferPaysOut: state => state.offerPaysOut,
    getOfferAdvertiserNames: state => state.offerAdvertiserNames,
    getOfferManagerNames: state => state.offerAdvertiserNames,
    getOfferExternalIds: state => state.offerExternalIds,
    getOfferCurrencies: state => state.offerCurrencies,
    getOfferVerticalsNames: state => state.offerVerticalsNames,
    getOfferStatuses: state => state.saveOfferStatuses,
    getOfferType: state => state.saveOfferType,
    getOfferIds: state => state.saveOfferId,
    getMultiplySelectOffers: state => state.multiplySelectOffers,
    getOfferPrograms: state => state.offerProgramNames,
  },

}
